import { Group, Text } from "@assetwatch/ui";
import type { TFunction } from "i18next";
import type { JobView } from "../motion-amplification/types";
import { JobThumbnail } from "./JobThumbnail";
import { statusLabel } from "./motionAmplificationJobState";

export function JobCard({
  view,
  selected,
  onSelect,
  t,
}: {
  view: JobView;
  selected: boolean;
  onSelect: () => void;
  t: TFunction;
}) {
  const { job, uploadState } = view;
  const title =
    job.name ||
    job.fileName ||
    t("motionAmplification.jobFallback", { id: job.jobId });

  return (
    <button
      type="button"
      aria-label={t("motionAmplification.selectVideoAria", { title })}
      aria-pressed={selected}
      className={`w-[200px] shrink-0 overflow-hidden rounded-(--radius-sm) border text-left ${selected ? "border-primary" : "border-outline-variant"}`}
      onClick={onSelect}
    >
      <JobThumbnail view={view} t={t} />
      <div className="p-(--spacing-8)">
        <Group justify="between" gap={8} wrap="nowrap">
          <Text truncate>{title}</Text>
          {job.status !== "Processing" && (
            <Text>{statusLabel(job, t, uploadState)}</Text>
          )}
        </Group>
      </div>
    </button>
  );
}
